import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AiService } from '../../services/ai.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'tangram-ai-suggest',
  templateUrl: './ai-suggest.component.html',
  styleUrls: ['./ai-suggest.component.scss']
})
export class AiSuggestComponent implements OnInit {
  @Input() videoId: string;
  @Input() pathwayId: string = '';
  @Input() isDashboard: boolean = false;
  @Input() subscriptionActive: boolean;

  // Parent should open its existing Add Question / Create Poll modal
  // pre-filled with the suggestion so the user can refine before submitting.
  @Output() addQuestion = new EventEmitter<any>();
  @Output() addPoll = new EventEmitter<any>();

  suggestions: any = null;
  isLoading: boolean = false;

  constructor(
    private aiService: AiService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {}

  getSuggestions(provider: 'gemini' | 'openai' = 'gemini') {
    // return; // TODO: Remove this once AI features are implemented
    if (!this.subscriptionActive) {
      this.toastr.warning('Active subscription required for AI features.');
      return;
    }

    const id = this.isDashboard ? this.pathwayId : this.videoId;
    if (!id) {
      return;
    }

    this.isLoading = true;
    this.suggestions = null;

    const request = this.isDashboard
      ? this.aiService.getTangramSuggestions(this.pathwayId, provider)
      : this.aiService.getMediaSuggestions(this.videoId, provider);

    request.subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res.success && res.data) {
          this.suggestions = res.data.suggestions;
        }
      },
      (error: any) => {
        this.isLoading = false;
        if (error.error && error.error.requiresSubscription) {
          this.toastr.warning('Active subscription required for AI features.');
        } else {
          this.toastr.error('Failed to generate suggestions. Please try again.');
        }
      }
    );
  }

  /** Canonical category keys used for CSS styling (open / multi / tf). */
  getQuestionCategory(type: string): 'open' | 'multi' | 'tf' {
    const t = (type || '').toLowerCase();
    if (t.includes('multiple') || t === 'mcq') return 'multi';
    if (t.includes('true') || t.includes('false') || t === 'tf') return 'tf';
    return 'open';
  }

  /**
   * Emit the suggestion so the parent can open its Add-Question modal
   * pre-filled. User refines the wording/options, then submits normally.
   */
  useQuestion(question: any) {
    this.addQuestion.emit(question);
  }

  /**
   * Emit the poll suggestion so the parent can open its Create-Poll modal
   * pre-filled for editing before submission.
   */
  usePoll(poll: any) {
    this.addPoll.emit(poll);
  }
}
